import { Button, Dialog } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMe } from '../identity/api';
import { ReleaseNotesList } from './ReleaseNotesList';
import { unseenNotes, useMarkReleaseSeen } from './releaseNotes';
import { useMeta } from './useMeta';

/**
 * "Neu in swarm": once per person and version after an update, listing the
 * notes of all versions missed (docs/ux-richtlinien.md §6.16). The seen
 * state lives on the server, so it holds across devices.
 */
export function WhatsNewDialog() {
  const { t } = useTranslation();
  const me = useMe();
  const meta = useMeta();
  const markSeen = useMarkReleaseSeen();
  const [dismissed, setDismissed] = useState(false);

  const running = meta.data?.version;
  const lastSeen = me.data?.last_seen_release;
  if (!running || !lastSeen) return null;
  const notes = unseenNotes(lastSeen, running);
  const newest = notes[0];
  if (!newest) return null;

  const close = () => {
    setDismissed(true);
    markSeen.mutate(running);
  };
  return (
    <Dialog
      open={!dismissed}
      onClose={close}
      title={t('releaseNotes.title', { version: newest.version.replace(/\.\d+$/, '') })}
      closeLabel={t('common.close')}
      actions={<Button onClick={close}>{t('releaseNotes.understood')}</Button>}
    >
      <ReleaseNotesList notes={notes} onNavigate={close} />
    </Dialog>
  );
}
